import type { DefaultColorScheme } from '@codegouvfr/react-dsfr/next-appdir';

export const defaultColorScheme: DefaultColorScheme = 'light';
